import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useField, FieldConfig, GenericFieldHTMLAttributes } from 'formik';

import { useModal } from '../hooks';
import { tripLoadedReqDataSelector, tripLoadingSelector } from '../../common/FillTrip';

export function useChange<Value>(
  props: GenericFieldHTMLAttributes & FieldConfig<Value>,
  // eslint-disable-next-line
): ReturnType<(e: React.ChangeEvent) => (e: never) => void> {
  const [{ onChange }] = useField(props);

  return useCallback(
    (e) => {
      props.onChange!(e);
      onChange(e);
    },
    [onChange, props.onChange],
  );
}

export const useLight = (name: string, value: any, requestParamName: any) => {
  const { isShow, openModal: showIcon, closeModal: hideIcon } = useModal();
  const [isSuccess, setIsSuccess] = useState(false);

  const isLoadingFields = useSelector(tripLoadingSelector);
  const { loaded, paramName } = useSelector(tripLoadedReqDataSelector);
  const { type: fieldName, value: loadedValue, isError } = loaded || { type: '', isError: false };

  const typeCard = name?.split('.')[0];
  const typeLoadedCard = fieldName?.split('.')[0];

  useEffect(() => {
    if (isLoadingFields || paramName !== requestParamName || typeCard !== typeLoadedCard) return;

    if (value === loadedValue) {
      setIsSuccess(!isError);
      showIcon();

      setTimeout(() => {
        hideIcon();
      }, 3000);
    }
  }, [isLoadingFields, paramName, loadedValue, value]);

  return { isShow, isSuccess };
};
